export const BOOLEAN = 'Boolean';
